// extracted by mini-css-extract-plugin
export var chip = "_ai-0";
export var filterDropdown = "_ai-5";
export var filterItem = "_ai-6";
export var icon = "_ai-1";
export var removeButton = "_ai-3";
export var removeIcon = "_ai-4";
export var separator = "_ai-2";